import { memo, useEffect, useMemo } from 'react';
import { useRates } from './ProductPricingWrapper';
import useVariation from '@hooks/useVariation';
import cx from '@utils/cx.util';

type Props = {
  isGenericProduct: boolean;
  isOutOfStock: boolean;
  isCustomShop: boolean;
  upcCode: string;
  item: any;
  addOns?: any[];
  customizationFees?: any;
  customRate?: any;
  className?: string;
};

const Affirm = ({
  isGenericProduct,
  isOutOfStock,
  isCustomShop,
  upcCode,
  item,
  addOns,
  customizationFees,
  customRate,
  className = '',
}: Props) => {
  const stableAddOns = useMemo(() => addOns || [], [addOns]);
  const stableCustomizationFees = useMemo(
    () => customizationFees || { total: 0, perItem: 0 },
    [customizationFees]
  );
  const stableCustomRate = useMemo(() => customRate || null, [customRate]);

  const rates = useRates({
    item,
    addOns: stableAddOns,
    isCustomShop,
    customizationFees: stableCustomizationFees,
    customRate: stableCustomRate,
  });
  const rate = rates.rate;
  const isVariant = useVariation('Enhanced PDP');

  const shouldRender = !isGenericProduct && !isOutOfStock && !isCustomShop && rates.rate > 190;

  useEffect(() => {
    if (!shouldRender) return;

    const timeout = setTimeout(() => {
      refreshAffirm();
    }, 2000);

    return () => clearTimeout(timeout);
  }, [shouldRender, rates]);

  if (!shouldRender) return null;

  return (
    <p
      className={cx(
        'affirm-as-low-as tw:min-h-6 tw:text-sm tw:font-normal tw:text-core-deep-navy',
        {
          'tw:text-center': isVariant,
        },
        className
      )}
      data-page-type='product'
      data-amount={rate * 100}
      data-sku={upcCode}></p>
  );
};

export default memo(Affirm);

const refreshAffirm = () => {
  if (window.affirmLoaded) {
    try {
      window.affirm?.ui?.refresh();
    } catch (e) {
      console.log('Unable to refresh affirm pricing: ' + e);
    }
  }
};
